// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-account-delete-server-connection-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-account-delete-server-connection-container,
.tenant-administrator-account-deleting-server-connection-container,
.tenant-administrator-account-deleted-server-connection-container{
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-account-delete-server-connection-container{
    padding: 16px 24px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-account-delete-server-connection-container h1{
    margin-top: 6px;
    font-size: 20px;
    font-weight: 500;
    color: rgb(48, 48, 48);
}
.tenant-administrator-account-delete-server-connection-container p{
    font-size: 14px;
    color: rgb(88, 88, 88);
}
.tenant-administrator-account-delete-server-connection-container .control-buttons-container{
    text-align: right;
    padding: 12px 0px;
}
.tenant-administrator-account-delete-server-connection-container .control-buttons-container button{
    border: none;
    margin-left: 24px;
    padding: 8px 25px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    color: rgb(255, 255, 255);
    background-color: rgba(153, 34, 34, 0.952);
    transition: background-color 0.25s ease;
}
.tenant-administrator-account-delete-server-connection-container .control-buttons-container button:hover{
    background-color: rgba(184, 24, 24, 0.952);
}
.tenant-administrator-account-deleting-server-connection-container{
    padding: 18px 56px;
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-account-deleting-server-connection-container div{
    width: 32px;
    height: 32px;
    border: 2px solid brown;
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-account-deleting-server-connection-container-spin 0.8s linear infinite;
}
@keyframes tenant-administrator-account-deleting-server-connection-container-spin{
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-account-deleting-server-connection-container p{
    font-size: 14px;
    color: rgb(92, 92, 92);
}

.tenant-administrator-account-deleted-server-connection-container{
    padding: 6px 16px;
    padding-right: 20px;
}
.tenant-administrator-account-deleted-server-connection-container p{
    margin: 0px;
    margin-top: 12px;
    margin-bottom: 8px;
    font-size: 14px;
    color: rgb(75, 75, 75);
}
.tenant-administrator-account-deleted-server-connection-container span{
    font-size: 16px;
    color: green;
    margin-right: 4px;
}
.tenant-administrator-account-deleted-server-connection-container .control-buttons-container{
    text-align: right;
    padding: 8px 0px;
}
.tenant-administrator-account-deleted-server-connection-container .control-buttons-container button{
    border: none;
    margin-left: 24px;
    padding: 8px 25px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    color: rgb(255, 255, 255);
    background-color: rgba(145, 40, 40, 0.952);
    transition: background-color 0.25s ease;
}
.tenant-administrator-account-deleted-server-connection-container .control-buttons-container button:hover{
    background-color: rgba(180, 52, 52, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Accounts/DeleteServerConnection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;;;IAGI,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,0CAA0C;IAC1C,uCAAuC;AAC3C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,sGAAsG;AAC1G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,0CAA0C;IAC1C,uCAAuC;AAC3C;AACA;IACI,0CAA0C;AAC9C","sourcesContent":[".tenant-administrator-account-delete-server-connection-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100vw;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.45);\n}\n.tenant-administrator-account-delete-server-connection-container,\n.tenant-administrator-account-deleting-server-connection-container,\n.tenant-administrator-account-deleted-server-connection-container{\n    border-radius: 4px;\n    background-color: white;\n}\n.tenant-administrator-account-delete-server-connection-container{\n    padding: 16px 24px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-account-delete-server-connection-container h1{\n    margin-top: 6px;\n    font-size: 20px;\n    font-weight: 500;\n    color: rgb(48, 48, 48);\n}\n.tenant-administrator-account-delete-server-connection-container p{\n    font-size: 14px;\n    color: rgb(88, 88, 88);\n}\n.tenant-administrator-account-delete-server-connection-container .control-buttons-container{\n    text-align: right;\n    padding: 12px 0px;\n}\n.tenant-administrator-account-delete-server-connection-container .control-buttons-container button{\n    border: none;\n    margin-left: 24px;\n    padding: 8px 25px;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: Roboto, sans-serif;\n    color: rgb(255, 255, 255);\n    background-color: rgba(153, 34, 34, 0.952);\n    transition: background-color 0.25s ease;\n}\n.tenant-administrator-account-delete-server-connection-container .control-buttons-container button:hover{\n    background-color: rgba(184, 24, 24, 0.952);\n}\n.tenant-administrator-account-deleting-server-connection-container{\n    padding: 18px 56px;\n    padding-top: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.tenant-administrator-account-deleting-server-connection-container div{\n    width: 32px;\n    height: 32px;\n    border: 2px solid brown;\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-account-deleting-server-connection-container-spin 0.8s linear infinite;\n}\n@keyframes tenant-administrator-account-deleting-server-connection-container-spin{\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-account-deleting-server-connection-container p{\n    font-size: 14px;\n    color: rgb(92, 92, 92);\n}\n\n.tenant-administrator-account-deleted-server-connection-container{\n    padding: 6px 16px;\n    padding-right: 20px;\n}\n.tenant-administrator-account-deleted-server-connection-container p{\n    margin: 0px;\n    margin-top: 12px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    color: rgb(75, 75, 75);\n}\n.tenant-administrator-account-deleted-server-connection-container span{\n    font-size: 16px;\n    color: green;\n    margin-right: 4px;\n}\n.tenant-administrator-account-deleted-server-connection-container .control-buttons-container{\n    text-align: right;\n    padding: 8px 0px;\n}\n.tenant-administrator-account-deleted-server-connection-container .control-buttons-container button{\n    border: none;\n    margin-left: 24px;\n    padding: 8px 25px;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: Roboto, sans-serif;\n    color: rgb(255, 255, 255);\n    background-color: rgba(145, 40, 40, 0.952);\n    transition: background-color 0.25s ease;\n}\n.tenant-administrator-account-deleted-server-connection-container .control-buttons-container button:hover{\n    background-color: rgba(180, 52, 52, 0.952);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
